import React, { useState } from 'react'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'
import { BtnAcao, Visualizar } from '../../../../components/Acoes'

const Consulta = props => {
    const [data, setData] = useState([])
    const [modalBloqueio, setModalBloqueio] = useState(false)
    const [itemSelecionado, setItemSelecionado] = useState(null)


    const columns = React.useMemo(
        () => [{
            id: 'consulta-cooperado-pf',
            columns: [
                {
                    Header: 'Código',
                    accessor: 'id',
                    ordenamento: {
                        tipo: 'numero',
                        ativo: true,
                        modo: 'desc',
                    }
                }, {
                    Header: 'Matrícula',
                    accessor: 'maco_id',
                    ordenamento: {
                        tipo: 'numero'
                    }
                },
                {
                    Header: 'Conselho',
                    accessor: 'conselho',
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'conselho_profissional',
                        idColuna: 'conselho_profissional.copr_id'
                    }
                },
                {
                    Header: 'Registro',
                    accessor: 'ccpf_registro_conselho',
                    ordenamento: {
                        tipo: 'numero'
                    }
                },
                {
                    Header: 'CBOS',
                    accessor: 'cbos_descricao',
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'cbos',
                        idColuna: 'cbos.cbos_id'
                    }
                }, {
                    Header: 'Nome',
                    accessor: 'copf_nome',
                    ordenamento: {
                        tipo: 'numero'
                    }
                },
                {
                    Header: 'CPF',
                    accessor: 'copf_cpf',
                    ordenamento: {
                        tipo: 'texto'
                    }
                },
                {
                    Header: 'Situação Administrativa',
                    accessor: 'siad_descricao',
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'situacao_administrativa',
                        idColuna: 'siad_id'
                    }
                },
                {
                    Header: 'Data Situação',
                    accessor: 'csad_data_situacao',
                    ordenamento: {
                        tipo: 'data'
                    }
                }
            ]
        }], []
    )

    const maisAcoesObj = [
        (propsAcao) => <BtnAcao icone="icon-Calendar-3 strikediag" action={() => {
            setItemSelecionado(propsAcao.row)
            setModalBloqueio(true);
        }} texto="Bloqueio de Agendamento" />,
        (propsAcao) => <Visualizar to={'/faturamento/cooperadopf/visualizacao/' + propsAcao.id} />
    ]

    return (
        <>
            <div>
                <DataGridAlternativa acoesObj={maisAcoesObj} data={data} columns={columns} setData={setData} acoes={true} caminhoBase='/faturamento/cooperadopf' caminhoConsultaFiltros='/faturamento/cooperadopfpaginacao' modulo={props.modulo} titulo={'Consulta Cooperado PF'}
                    tituloLista={'Lista Cooperado PF'} icone={props.icone} />
            </div>
        </>
    )
}

export default Consulta